import { AlbumContentType } from 'common/enums';
import { FileIcon, RecordingIcon, VideoIcon, WriteIcon } from '.';

export const ContentIcons: Record<AlbumContentType, React.ReactNode> = {
  [AlbumContentType.video]: <VideoIcon />,
  [AlbumContentType.audio]: <RecordingIcon />,
  [AlbumContentType.image]: <FileIcon />,
  [AlbumContentType.document]: <FileIcon />,
  [AlbumContentType.write]: <WriteIcon />,
};
